(ns manatee.components.icon-animated.components
  (:require
   [rothko.icon.component :refer [icon]]))

(defn icon-animated
  [{icon-name :icon class :class :as props}]
  [icon (merge props
               {:class (concat class
                               [:icon-animated (str "icon-animated-"
                                                    (name icon-name))])})])

(defn spinner
  [props]
  [icon-animated (merge props
                        {:icon :spinner})])
